<script>
export default {
  name: 'GalleryProductView',
  props: {
    images: Array,
  },
  data() {
    return {
      activeImageIndex: 0,
      ready: true,
    }
  },
  computed: {
    activeImage() {
      return this.images[this.activeImageIndex]
    },
    nextIsDisabled() {
      return this.images.length - 1 <= this.activeImageIndex
    },
    prevIsDisabled() {
      return 0 === this.activeImageIndex
    },
  },
  methods: {
    setActiveIndex(index) {
      this.activeImageIndex = index

      const zoom = [...document.getElementsByClassName('refszoom')]

      if (!zoom.length) return

      if (this.activeImage.images) {
        zoom.forEach(el => el.style.display = 'none')
      } else {
        zoom.forEach(el => el.style.display = 'flex')
      }
    },

    setNextIndex() {
      const newIndex = this.activeImageIndex + 1

      if (newIndex > this.images.length) return

      this.setActiveIndex(newIndex)
    },

    setPrevIndex() {
      const newIndex = this.activeImageIndex - 1

      if (0 > newIndex) return

      this.setActiveIndex(newIndex)
    },
  },
  render() {
    return this.$scopedSlots.default({
      active_index: this.activeImageIndex,
      set_active_index: this.setActiveIndex,
      active_image: this.activeImage,
      ready: this.ready,
      nextIsDisabled: this.nextIsDisabled,
      prevIsDisabled: this.prevIsDisabled,
      setNextIndex: this.setNextIndex,
      setPrevIndex: this.setPrevIndex,
    })
  },
}
</script>
